<template>
  <div id="hres83e">
    <hrms-search-box-table v-show="indexDisp"
            v-model="searchIndex"
            :data="index"
            :nowLang="app.nowLang"
            :columns="columns[app.nowLang].index"
            :unLoadBool="true"
            :receivedStore="receivedHres83eIndex"
            searchBoxAlias="hres83e"
            :detailEvent="assetDetailEvent"
            :editEvent="editEvent" />

    <asset-detail v-show="assetDetailDisp"
            :labels="labels[app.nowLang]"
            :labelsButton="app.button[app.nowLang]"
            :detail="assetDetail"
            :toggle="toggle"
            :nowLang="app.nowLang" />

    <detail  v-show="detailDisp"
            :calendarDetailDisp="calendarDetailDisp"
            :reserveDisp="reserveDisp"
            :labels="labels[app.nowLang]"
            :labelsButton="app.button[app.nowLang]"
            :toggle="toggle"
            :nowLang="app.nowLang"
            :reserveDay="reserveDay"
            :reserveDate="reserveDate"
            :reserveMonth="reserveMonth"
            :reserveYear="reserveYear"
            :searchIndex="searchIndex"
            :dateSelected="dateSelected"
            :indexSelected="indexSelected"
            :calendarSelected="calendarSelected"
            :setDateSelected="setDateSelected"
            :setCalendarSelected="setCalendarSelected"
            :calendar="calendar"
            :calendarDetail="calendarDetail"
            :reserveDetail="reserveDetail"
            :detailColumns="columns[app.nowLang].detail"
            :descCodapp="app.$children[0].descCodapp"
            :receivedHres83eCalendar="receivedHres83eCalendar"
            :receivedHres83eReserveDetail="receivedHres83eReserveDetail"
            :receivedHres83eReserveCreate="receivedHres83eReserveCreate"
            :postHres83eReserveCancel="postHres83eReserveCancel"
            :postHres83eReserveSave="postHres83eReserveSave" />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hres83e/mutation-types'
import assetDetail from 'components/hres83e/assetDetail'
import detail from 'components/hres83e/detail'
import reserve from 'components/hres83e/reserve'
import moment from 'moment'

export default {
  name: 'hres83e',
  data () {
    return {
      searchIndex: {
        dtereserv: moment().format('DD/MM/YYYY')
      },
      app: this.$parent.$parent.$parent,
      currentDtereq: moment().format('DD/MM/YYYY'),
      currentNumseq: 1
    }
  },
  created () {
    this.receivedHres83eColumnsLabels()
  },
  computed: {
    reserveDay () {
      return this.dateSelected.length === 10 ? new Date(this.reserveYear, this.reserveMonth - 1, this.reserveDate).getDay() : ''
    },
    reserveDate () {
      return this.dateSelected.length === 10 ? this.dateSelected.substring(0, 2) : ''
    },
    reserveMonth () {
      return this.dateSelected.length === 10 ? this.dateSelected.substring(3, 5) : ''
    },
    reserveYear () {
      return this.dateSelected.length === 10 ? this.dateSelected.substring(6, 10) : ''
    },
    ...mapGetters({
      indexDisp: types.GET_HRES83E_INDEX_DISP,
      assetDetailDisp: types.GET_HRES83E_ASSET_DETAIL_DISP,
      detailDisp: types.GET_HRES83E_DETAIL_DISP,
      calendarDetailDisp: types.GET_HRES83E_CALENDAR_DETAIL_DISP,
      reserveDisp: types.GET_HRES83E_RESERVE_DISP,
      columns: types.GET_HRES83E_COLUMNS,
      labels: types.GET_HRES83E_LABELS,
      index: types.GET_HRES83E_INDEX,
      indexSelected: types.GET_HRES83E_INDEX_SELECTED,
      calendarSelected: types.GET_HRES83E_CALENDAR_SELECTED,
      dateSelected: types.GET_HRES83E_DATE_SELECTED,
      assetDetail: types.GET_HRES83E_ASSET_DETAIL,
      calendar: types.GET_HRES83E_CALENDAR,
      calendarDetail: types.GET_HRES83E_CALENDAR_DETAIL,
      reserveDetail: types.GET_HRES83E_RESERVE_DETAIL
    })
  },
  watch: {
    dateSelected () {
      this.receivedCalendarDetail()
    }
  },
  methods: {
    receivedCalendarDetail () {
      if (typeof this.indexSelected.assetno !== 'undefined') {
        let searchParams = {
          assetno: this.indexSelected.assetno,
          typasset: this.indexSelected.typasset,
          dtereserv: this.dateSelected
        }
        this.receivedHres83eCalendarDetail(searchParams)
      }
    },
    pageDetail (event, param) {
      switch (event) {
        case 'assetDetail':
          if (param.assetno) {
            let searchParams = {
              assetno: param.assetno
            }
            this.receivedHres83eAssetDetail(searchParams)
            this.toggle('assetDetail')
          }
          break
        case 'detail':
          this.setDateSelected(this.searchIndex.dtereserv)
          let searchParams = {
            assetno: param.assetno,
            dtemonth: this.reserveMonth,
            dteyear: this.reserveYear
          }
          this.receivedHres83eCalendar(searchParams)
          this.receivedCalendarDetail()
          this.toggle('detail')
          break
        default:
          break
      }
    },
    assetDetailEvent (param) {
      this.setIndexSelected(param)
      this.pageDetail('assetDetail', param)
    },
    editEvent (param) {
      this.setIndexSelected(param)
      this.pageDetail('detail', param)
    },
    ...mapMutations({
      setIndexSelected: types.SET_HRES83E_INDEX_SELECTED,
      setCalendarSelected: types.SET_HRES83E_CALENDAR_SELECTED,
      setDateSelected: types.SET_HRES83E_DATE_SELECTED
    }),
    ...mapActions({
      toggle: types.TOGGLE_HRES83E_PAGE,
      receivedHres83eColumnsLabels: types.RECEIVED_HRES83E_COLUMNS_LABELS,
      receivedHres83eIndex: types.RECEIVED_HRES83E_INDEX,
      receivedHres83eAssetDetail: types.RECEIVED_HRES83E_ASSET_DETAIL,
      receivedHres83eCalendar: types.RECEIVED_HRES83E_CALENDAR,
      receivedHres83eCalendarDetail: types.RECEIVED_HRES83E_CALENDAR_DETAIL,
      receivedHres83eReserveDetail: types.RECEIVED_HRES83E_RESERVE_DETAIL,
      receivedHres83eReserveCreate: types.RECEIVED_HRES83E_RESERVE_CREATE,
      postHres83eReserveCancel: types.POST_HRES83E_RESERVE_CANCEL,
      postHres83eReserveSave: types.POST_HRES83E_RESERVE_SAVE
    })
  },
  components: {
    assetDetail,
    detail,
    reserve
  }
}
</script>

<style src="./style.scss" lang='scss'></style>


// WEBPACK FOOTER //
// component.vue?a138fd9c